import React from 'react';
import { DashboardMenuItem, Menu, MenuItemLink, getResources } from 'react-admin';

import { useSelector } from 'react-redux';

import DefaultIcon from '@material-ui/icons/ViewList';

import AccountIcon from '@material-ui/icons/AccountBalanceWallet';
import PeopleIcon from '@material-ui/icons/People';
import LabelIcon from '@material-ui/icons/Label';
import FaceIcon from '@material-ui/icons/Face';
import InfoIcon from '@material-ui/icons/Info';
import KeyIcon from '@material-ui/icons/VpnKey';
import LockIcon from '@material-ui/icons/Lock';
import MoneyIcon from '@material-ui/icons/Money';
import ReceiptIcon from '@material-ui/icons/Receipt';

function getResourceIcon(resource) {
	switch(resource.name) {
		case 'accounts':
			return (<AccountIcon />);
		case 'cryptoKeys':
			return (<KeyIcon />);
		case 'transactions':
			return (<ReceiptIcon />);
		case 'erc20tokens':
			return (<MoneyIcon />);
		case 'profile':
			return (<FaceIcon />);
		case 'local-vaults':
			return (<LockIcon />);
		default:
			return(<resource.icon />);
	}
}

const hidden_resources = ['profile'];

export const MyLeftBarMenu = (props) => {
	const resources = useSelector(getResources);

	return (
		<Menu {...props}>
			<DashboardMenuItem />

			{resources
			 .filter(resource => !hidden_resources.includes(resource.name))
			.map(resource => (
				<MenuItemLink
					key={resource.name}
					to={`/${resource.name}`}
					primaryText={
						(resource.options && resource.options.label) ||
						resource.name
					}
					leftIcon={
						resource ? getResourceIcon(resource): <DefaultIcon />
					}
				/>
			))}
			
			<MenuItemLink to="/about" primaryText="About" leftIcon={<InfoIcon />}/>
		</Menu>
	);
};


